export class OrganisationTypeConstants {
  public static readonly DEVELOPER = "Developer";

  public static readonly STANDARD = "Standard";

  public static readonly VERIFIER = "Verifier";

  public static readonly DEVELOPMENT_MANAGER = "DevelopmentManager";

  public static readonly ASSET_MANAGER = "AssetManager";

  public static readonly BADGE = "Badge";

  public static readonly GUEST = "Guest";
}

export type UserType =
  | typeof OrganisationTypeConstants.DEVELOPER
  | typeof OrganisationTypeConstants.VERIFIER
  | typeof OrganisationTypeConstants.DEVELOPMENT_MANAGER
  | typeof OrganisationTypeConstants.ASSET_MANAGER;

export const UserTypeLabels: Record<string, string> = {
  [OrganisationTypeConstants.DEVELOPER]: "Developer",
  [OrganisationTypeConstants.VERIFIER]: "Verifier",
  [OrganisationTypeConstants.DEVELOPMENT_MANAGER]: "Development Manager",
  [OrganisationTypeConstants.ASSET_MANAGER]: "Asset Manager",
};
